// Auto-generated from "TACH Dispatch Services Terms of Use Agreement.docx" (THT-685).
// Full TACH Dispatch Services Terms of Use, shown on the Request-a-Load review
// step behind the Terms & Services gate. Ported verbatim from the mobile
// constant (tach-mobile/app/constants/dispatchTerms.ts) so both surfaces present
// the identical agreement. The .docx is the source of truth — regenerate this
// file whenever the terms change, and keep the two copies in sync.

export const DISPATCH_TERMS_HTML = `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"><style>body{font-family:-apple-system,Roboto,"Helvetica Neue",Arial,sans-serif;color:#1a1a1a;line-height:1.5;padding:16px 18px 40px;font-size:13px;-webkit-text-size-adjust:100%;}h1{font-size:17px;text-align:center;margin:8px 0 16px;}h2{font-size:14px;margin:22px 0 6px;}h3{font-size:13px;margin:16px 0 4px;}p{margin:8px 0;}ul{padding-left:20px;margin:6px 0;}li{margin:3px 0;}</style></head><body><p><strong>TACH DISPATCH SERVICES TERMS OF USE</strong></p>
<p><strong>Effective Date</strong></p>
<p>These Dispatch Services Terms of Use ("Terms") govern the use of Dispatch Services offered through the TACH platform.</p>
<p>By selecting <strong>"Request Dispatch Services"or “Get Me Freight”</strong>, clicking <strong>"I Agree"</strong>, or otherwise using Dispatch Services through the TACH platform, you ("Member" or "Carrier") acknowledge that you have read, understood, and agree to be legally bound by these Terms.</p>
<p><strong>1. Dispatch Services</strong></p>
<p>TACH provides dispatch coordination and administrative support services to qualified motor carriers operating under their own federal and/or state operating authority.</p>
<p>Dispatch Services may include:</p>
<ul>
<li><p>locating freight opportunities</p></li>
<li><p>communicating with brokers and shippers</p></li>
<li><p>negotiating freight rates within Member-authorized parameters</p></li>
<li><p>submitting carrier packets</p></li>
<li><p>transmitting rate confirmations</p></li>
<li><p>load tracking</p></li>
<li><p>detention requests</p></li>
<li><p>TONU requests</p></li>
<li><p>scheduling pickup and delivery appointments</p></li>
<li><p>document management</p></li>
<li><p>billing assistance</p></li>
<li><p>related administrative dispatch functions</p></li>
</ul>
<p>Dispatch Services are administrative only.</p>
<p>TACH is <strong>not</strong> a motor carrier, freight broker, shipper, or transportation provider with respect to loads accepted by Member.</p>
<p><strong>2. Dispatch Services May Be Performed by TACH or Third Parties</strong></p>
<p>Member understands and agrees that TACH may, in its sole discretion:</p>
<ul>
<li><p>perform Dispatch Services directly;</p></li>
<li><p>subcontract Dispatch Services;</p></li>
<li><p>outsource Dispatch Services to one or more independent third-party dispatch companies;</p></li>
<li><p>replace dispatch providers at any time without notice.</p></li>
</ul>
<p>Member expressly authorizes TACH to share information reasonably necessary to perform Dispatch Services with approved third-party dispatch providers acting on TACH's behalf, including:</p>
<ul>
<li><p>company information</p></li>
<li><p>insurance information</p></li>
<li><p>operating authority</p></li>
<li><p>driver information</p></li>
<li><p>equipment information</p></li>
<li><p>load information</p></li>
<li><p>broker communications</p></li>
<li><p>documents necessary to perform dispatch services</p></li>
</ul>
<p>Any third-party dispatch provider engaged by TACH shall be deemed an independent contractor of TACH.</p>
<p>TACH remains the Member's contractual relationship regardless of which dispatch provider performs the services.</p>
<p><strong>3. No Guarantee of Freight</strong></p>
<p>TACH does not guarantee:</p>
<ul>
<li><p>any minimum number of loads</p></li>
<li><p>freight availability</p></li>
<li><p>revenue</p></li>
<li><p>profitability</p></li>
<li><p>broker approval</p></li>
<li><p>payment by brokers or shippers</p></li>
</ul>
<p>All freight opportunities remain subject to market availability.</p>
<p><strong>4. Dispatch Fees</strong></p>
<p>Member agrees to pay the dispatch fee disclosed within the TACH platform at the time Dispatch Services are requested.</p>
<p>Unless otherwise specified, the dispatch fee shall equal:</p>
<p><strong>5% of the gross linehaul amount</strong></p>
<p>subject to a minimum fee of</p>
<p><strong>$45 per completed load.</strong></p>
<p>TACH reserves the right to modify dispatch pricing upon prior notice posted within the platform.</p>
<p><strong>5. Payment Authorization</strong></p>
<p>By requesting Dispatch Services, Member authorizes TACH to collect all dispatch fees owed through any payment method authorized within the Member's TACH account, including:</p>
<ul>
<li><p>TACH platform settlement deductions where applicable</p></li>
<li><p>ACH</p></li>
<li><p>debit card</p></li>
<li><p>credit card</p></li>
<li><p>other authorized electronic payment methods</p></li>
</ul>
<p>Member authorizes recurring charges for Dispatch Services performed.</p>
<p>Chargebacks for legitimately earned dispatch fees constitute a material breach of these Terms.</p>
<p><strong>6. Authority Granted to TACH</strong></p>
<p>Member grants TACH a limited authorization to:</p>
<ul>
<li><p>communicate with brokers</p></li>
<li><p>communicate with shippers</p></li>
<li><p>submit carrier packets</p></li>
<li><p>transmit certificates of insurance</p></li>
<li><p>negotiate freight rates within Member-approved guidelines</p></li>
<li><p>electronically acknowledge and sign routine dispatch documents</p></li>
<li><p>submit detention requests</p></li>
<li><p>request TONU compensation</p></li>
<li><p>obtain pickup and delivery information</p></li>
<li><p>coordinate appointments</p></li>
<li><p>communicate carrier location &amp; shipment status</p></li>
</ul>
<p>This authorization does <strong>not</strong> permit TACH to:</p>
<ul>
<li><p>endorse checks</p></li>
<li><p>open bank accounts</p></li>
<li><p>incur debt</p></li>
<li><p>settle legal claims</p></li>
<li><p>admit liability</p></li>
<li><p>waive legal rights</p></li>
<li><p>execute agreements unrelated to Dispatch Services.</p></li>
</ul>
<p><strong>7. Member Responsibilities</strong></p>
<p>Member remains solely responsible for:</p>
<ul>
<li><p>operating authority</p></li>
<li><p>DOT compliance</p></li>
<li><p>FMCSA compliance</p></li>
<li><p>Hours-of-Service compliance</p></li>
<li><p>Maintain vehicle ELD/Telematics communications w/TACH</p></li>
<li><p>vehicle maintenance</p></li>
<li><p>driver qualification</p></li>
<li><p>cargo securement</p></li>
<li><p>insurance</p></li>
<li><p>freight transportation</p></li>
<li><p>regulatory compliance</p></li>
<li><p>safety</p></li>
<li><p>taxes</p></li>
<li><p>permits</p></li>
<li><p>licensing</p></li>
</ul>
<p>Nothing contained within these Terms transfers transportation responsibility to TACH.</p>
<p><strong>8. Insurance Requirements</strong></p>
<p>Member agrees to maintain throughout the term:</p>
<ul>
<li><p>active USDOT registration</p></li>
<li><p>active FMCSA operating authority</p></li>
<li><p>all legally required licenses</p></li>
<li><p>automobile liability insurance</p></li>
<li><p>cargo insurance</p></li>
<li><p>workers compensation where required</p></li>
<li><p>any insurance required by brokers or shippers</p></li>
</ul>
<p>Failure to maintain required insurance may result in immediate suspension of Dispatch Services.</p>
<p><strong>9. Broker Payments</strong></p>
<p>Member acknowledges that brokers and shippers—not TACH—are responsible for payment of freight charges.</p>
<p>TACH makes no guarantee regarding payment by any broker, factoring company, shipper, or customer.</p>
<p><strong>10. Suspension or Termination</strong></p>
<p>TACH may suspend or terminate Dispatch Services immediately for:</p>
<ul>
<li><p>non-payment</p></li>
<li><p>insurance lapse</p></li>
<li><p>operating authority suspension</p></li>
<li><p>fraud</p></li>
<li><p>unsafe operations</p></li>
<li><p>excessive service failures</p></li>
<li><p>repeated cancellations</p></li>
<li><p>violation of these Terms</p></li>
<li><p>conduct that may expose TACH or its partners to liability.</p></li>
</ul>
<p>Member may discontinue Dispatch Services at any time through the TACH platform.</p>
<p>Termination does not eliminate any fees already earned.</p>
<p><strong>11. Confidentiality</strong></p>
<p>Member agrees not to disclose confidential information obtained through Dispatch Services including:</p>
<ul>
<li><p>broker lists</p></li>
<li><p>customer relationships</p></li>
<li><p>pricing</p></li>
<li><p>proprietary procedures</p></li>
<li><p>internal business information</p></li>
</ul>
<p><strong>12. Non-Solicitation</strong></p>
<p>For three (3) months following the last Dispatch Service performed through TACH, Member agrees not to intentionally bypass TACH by directly contracting with brokers or customers first introduced through TACH Dispatch Services.</p>
<p><strong>13. Audit Rights</strong></p>
<p>TACH may request records reasonably necessary to verify dispatch fees including:</p>
<ul>
<li><p>rate confirmations</p></li>
<li><p>invoices</p></li>
<li><p>proofs of delivery</p></li>
<li><p>payment confirmations</p></li>
</ul>
<p>If an audit reveals underpayment exceeding five percent (5%), Member agrees to promptly pay all outstanding amounts.</p>
<p><strong>14. Indemnification</strong></p>
<p>Member agrees to defend, indemnify, and hold harmless TACH, its affiliates, officers, directors, employees, contractors, agents, and third-party dispatch providers from claims arising out of:</p>
<ul>
<li><p>transportation services</p></li>
<li><p>vehicle operations</p></li>
<li><p>driver conduct</p></li>
<li><p>cargo claims</p></li>
<li><p>accidents</p></li>
<li><p>bodily injury</p></li>
<li><p>property damage</p></li>
<li><p>regulatory violations</p></li>
<li><p>Member's breach of these Terms</p></li>
</ul>
<p>except to the extent caused by TACH's gross negligence or willful misconduct.</p>
<p><strong>15. Data Sharing</strong></p>
<p>Member authorizes TACH to use and share Member information with third parties directly involved in providing requested services, including:</p>
<ul>
<li><p>dispatch providers</p></li>
<li><p>insurance partners</p></li>
<li><p>brokers</p></li>
<li><p>payment processors</p></li>
<li><p>technology providers</p></li>
<li><p>compliance providers</p></li>
<li><p>telematics providers</p></li>
<li><p>roadside assistance providers</p></li>
<li><p>rental vehicle providers</p></li>
<li><p>factoring partners</p></li>
<li><p>financing partners</p></li>
</ul>
<p>solely for purposes of providing requested services and operating the TACH platform in accordance with the TACH Privacy Policy.</p>
<p><strong>16. Marketing Consent</strong></p>
<p>Unless revoked in writing, Member grants TACH permission to reference Member's company name and logo solely as a TACH Member in marketing materials.</p>
<p>No confidential information shall be disclosed.</p>
<p><strong>17. Governing Law</strong></p>
<p>These Terms shall be governed by the laws of the State of Georgia.</p>
<p>Any dispute shall first be submitted to informal resolution.</p>
<p>If unresolved within fifteen (15) days, exclusive jurisdiction shall lie through Arbitration in the state of Georgia.</p>
<p><strong>18. Changes to These Terms</strong></p>
<p>TACH may modify these Terms from time to time.</p>
<p>Continued use of Dispatch Services after updated Terms become effective constitutes acceptance of the revised Terms.</p>
<p><strong>19. Electronic Acceptance</strong></p>
<p>By clicking:</p>
<p><strong>☐ I have read and agree to the TACH Dispatch Services Terms of Use</strong></p>
<p>the Member:</p>
<ul>
<li><p>agrees to these Terms;</p></li>
<li><p>confirms it has authority to bind the motor carrier;</p></li>
<li><p>authorizes TACH to perform or arrange Dispatch Services;</p></li>
<li><p>authorizes TACH to engage qualified third-party dispatch providers when appropriate;</p></li>
<li><p>authorizes TACH to collect applicable Dispatch Service fees through approved payment methods;</p></li>
<li><p>agrees that this electronic acceptance constitutes a legally binding electronic signature under the U.S. Electronic Signatures in Global and National Commerce Act (E-SIGN Act) and the Uniform Electronic Transactions Act (UETA), with the same force and effect as a handwritten signature.</p></li>
</ul>
</body></html>`
